export enum SessionState {
    LoggedIn,
    PasswordChangeRequired,
    LoggedOut,
    Unknown,
}
